import setFolderMruConfigurationService from '../services/setFolderMruConfigurationService';
import { getStore } from '../store/store';
import { action } from 'satcheljs/lib/legacy';
var MAX_MRU_FOLDER_COUNT = 10;
/**
 * Action to add a folderId to Mru list and save it to server
 * @param folderId - folderIs to add to mru list
 */
export default action('addFolderIdToMoveToMruList')(function addFolderIdToMoveToMruList(folderId) {
    updateFolderMruList(folderId);
    var store = getStore();
    if (store.isInitialized) {
        setFolderMruConfigurationService(store.mruFolders);
    }
});
function updateFolderMruList(folderId) {
    var store = getStore();
    var index = store.mruFolders.indexOf(folderId);
    if (index >= 0) {
        // Move the folderId to front if it already exists in the list
        store.mruFolders.splice(index, 1);
        store.mruFolders.unshift(folderId);
    }
    else {
        // Add folderId to front of the list and trim the list
        store.mruFolders.unshift(folderId);
        store.mruFolders.splice(MAX_MRU_FOLDER_COUNT);
    }
}
//# sourceMappingURL=addFolderIdToMoveToMruList.js.map